import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllEmailAction,
  searchAction,
} from '../../../redux/actions/communicationAction';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  FormControl,
  Select,
  Pagination,
  MenuItem,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SendEmailDialog from './SendEmailDialog';

const Email = ({
  poppinsFont,
  openSendDialog,
  policyId,
  setOpenSendDialog,
  hasSearched,
  formData,
}) => {
  const [emailPage, setEmailPage] = useState(0);
  const [rowsPerPageEmail, setRowsPerPageEmail] = useState(5);

  const dispatch = useDispatch();

  // Normal emails (unfiltered)
  const emails = useSelector(
    (state) => state.communication?.allEmail?.content || []
  );
  const emailsPagination = useSelector(
    (state) => state.communication?.allEmail || { totalElements: 0, page: 0 }
  );

  // Filtered emails (after search)
  const searchEmails = useSelector(
    (state) => state.communication?.allSearch?.content || []
  );
  const searchPagination = useSelector(
    (state) => state.communication?.allSearch || { totalElements: 0, page: 0 }
  );

  // Initial + pagination fetch for ALL emails
  // useEffect(() => {
  //   if (!hasSearched) {
  //     dispatch(getAllEmailAction(emailPage, rowsPerPageEmail));
  //   }
  // }, [dispatch]);

  // Decide what to render
  const activeData = hasSearched ? searchEmails : emails;
  const activePagination = hasSearched ? searchPagination : emailsPagination;

  const handleChangePageEmail = (event, newPage) => {
    setEmailPage(newPage);

    if (hasSearched) {
      dispatch(searchAction(formData, newPage, rowsPerPageEmail));

    } else {
      dispatch(getAllEmailAction(newPage, rowsPerPageEmail));
    }
  };

  const handleChangeRowsPerPageEmail = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPageEmail(newSize);
    setEmailPage(0);

    if (hasSearched) {
      dispatch(searchAction(formData, 0, newSize));

    } else {
      dispatch(getAllEmailAction(0, newSize));
    }
  };

  return (
    <>
      {renderTable(
        activeData,
        'Email',
        activePagination,
        emailPage,
        rowsPerPageEmail,
        handleChangePageEmail,
        handleChangeRowsPerPageEmail,
        poppinsFont
      )}

      <SendEmailDialog
        open={openSendDialog}
        onClose={() => setOpenSendDialog(false)}
        clientCustomerId={123}
        policyId={policyId}
      />
    </>
  );
};

export default Email;

const renderTable = (
  data = [],
  label,
  pagination,
  page,
  rowsPerPage,
  handlePageChange,
  handleRowsPerPageChange,
  poppinsFont
) => {
  return (
    <Box sx={{ ml: 2, mr: 2, mb: 2, mt: 2 }}>
      <Accordion defaultExpanded sx={{ mt: 2, backgroundColor: '#f5f5f5' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={poppinsFont}>{label}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {data.length > 0 ? (
            <>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>
                        Policy Number
                      </TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Type</TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Date</TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Subject</TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Delivered</TableCell>
                      <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Response</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row, index) => (
                      <TableRow className="styled-table-row" key={index}>
                        <TableCell>{row.policyNumber}</TableCell>
                        <TableCell>{row.type}</TableCell>
                        <TableCell>{row.date}</TableCell>
                        <TableCell>{row.subject}</TableCell>
                        <TableCell>{row.delivered ? 'Yes' : 'No'}</TableCell>
                        <TableCell>{row.response}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {pagination.totalElements > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  mt={2}
                  px={2}
                >
                  <span style={{ marginRight: 8, fontSize: '14px' }}>
                    Rows per page:
                  </span>
                  <FormControl size="small">
                    <Select
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                      displayEmpty
                    >
                      {[5, 10, 25].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Pagination
                    count={Math.ceil(pagination.totalElements / rowsPerPage)}
                    page={page + 1}
                    onChange={(event, value) =>
                      handlePageChange(event, value - 1)
                    }
                  />
                </Box>
              )}
            </>
          ) : (
            <Typography align="center" sx={{ mt: 2 }}>
              No Record Found
            </Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
